import { styled } from '@mui/material/styles';
import { Div } from '../../../../components/templates/MainPartEdit/MainPartEdit.styles';

export const StyledLiveSearchDiv = styled(Div)`
  width: 250px;
`;